<script setup lang="ts">
import { PathSegment } from './sub-components/path-segment';
import { DropZone } from '@/components/document/sub-components/file-manager/sub-components/drop-zone';
import { useFileManagerNavigation } from '@/components/document/sub-components/file-manager/logic/core/useFileManagerNavigation';

const props = defineProps<{
  segment: string;
  path: string;
}>();

const { navigateTo } = useFileManagerNavigation();
</script>

<template>
  <DropZone
    :path="props.path"
    v-slot="{ isDragOver, onDragEnter, onDragLeave, onDragOver, onDrop }"
  >
    <button
      type="button"
      class="button is-small dnd-path-segment"
      :class="{ 'is-drag-over': isDragOver }"
      @click="navigateTo(props.path)"
      @dragenter.prevent="onDragEnter"
      @dragover="onDragOver"
      @dragleave="onDragLeave"
      @drop.prevent="onDrop"
    >
      <PathSegment :segment="segment" />
    </button>
  </DropZone>
</template>

<style scoped>
.dnd-path-segment {
  flex-shrink: 0;
  height: 2.625rem;
  padding: 0 0.6em;
  border: none;
  border-radius: 0.375rem;
  background-color: transparent;
  box-shadow: none;
  color: #001c74;
  font-size: 1.0625rem;
  line-height: 2.625rem;
}

.dnd-path-segment:hover {
  background-color: #e6ecfb;
}

.dnd-path-segment.is-drag-over {
  background-color: color-mix(in srgb, var(--primary-color) 10%, transparent);
}
</style>
